var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5227 18.0001C26.5227 22.7071 22.707 26.5228 18 26.5228C13.293 26.5228 9.47726 22.7071 9.47726 18.0001C9.47726 13.2931 13.293 9.47738 18 9.47738C22.707 9.47738 26.5227 13.2931 26.5227 18.0001ZM29.3636 18.0001C29.3636 24.2761 24.276 29.3637 18 29.3637C11.724 29.3637 6.63635 24.2761 6.63635 18.0001C6.63635 11.7241 11.724 6.63647 18 6.63647C24.276 6.63647 29.3636 11.7241 29.3636 18.0001ZM16.5795 19.4206V13.7387H19.4204V18.2438L23.6104 22.4338L21.6016 24.4426L16.5795 19.4206Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcn);
export default __webpack_public_path__ + "static/media/clock-icn.218ed96a766d4fd3ec269b2e73a9e7aa.svg";
export { ForwardRef as ReactComponent };